export default "__VITE_ASSET__Bg97F7oZ__"